import * as Library from "../../../../utils/Library";

// #region REQUESTS
export async function requestSubscriptionPlanSet({ organizationID, subscriptionPlanSetID, setLoader }) {
    const res = await Library.makeApiRequest({
        endpoint: "Billing/getSubscriptionPlanSet",
        data: {
            organizationID,
            subscriptionPlanSetID
        },
        setLoader
    });

    if (res?.data?.status !== 200) return undefined;
    return res?.data?.data ?? null;
}

export async function requestStripePaymentMethod({ companyID, onError }) {
    const res = await Library.makeApiRequest({
        endpoint: "Global/getPaymentMethods",
        data: { companyID },
        onError
    });

    if (res?.data?.status !== 200) return null;

    const paymentMethods = res?.data?.data?.results || [];

    return {
        hasPaymentMethods: paymentMethods.length > 0,
        stripePaymentMethodID: paymentMethods[0]?.stripePaymentMethodID || null
    };
}

export async function requestLatestInvoice({ companyID, onError }) {
    const res = await Library.makeApiRequest({
        endpoint: "Billing/getInvoices",
        data: { companyID },
        onError
    });

    if (res?.data?.status !== 200) return null;
    return { invoice: res?.data?.data?.result?.[0] };
}

export async function requestSubscriptionActivation({
    organizationID,
    subscriptionPlanIDs,
    stripePaymentMethodID,
    BOstagesAccountID,
    subscriptionPlanTime,
    reconcileOnly = false,
    onError
}) {
    const res = await Library.makeApiRequest({
        endpoint: "Billing/setSubscriptionPlan",
        data: {
            organizationID,
            subscriptionPlanIDs,
            subscriptionPlanTime,
            stripePaymentMethodID,
            BOstagesAccountID,
            reconcileOnly
        },
        onErrorShowMsg: false,
        onError: response => {
            // Expected billing states are handled by the page after the shared
            // helper resolves. Unexpected/transport errors still clean up loaders.
            if (isBillingOutcome(response?.data)) return;
            Library.showToastMessage({
                type: "error",
                title: response?.data?.message || response?.message || "Payment could not be confirmed."
            });
            onError?.(response);
        }
    });

    if (isBillingOutcome(res?.data)) {
        const data = res.data.data;
        return { ...data, paymentURL: currentPaymentURL(data.paymentURL), message: data.message || res.data.message };
    }
    if (res?.data?.status !== 200 || !isVerifiedActivation(res?.data?.data)) return null;
    return res.data.data;
}

function isBillingOutcome(body) {
    const codes = {
        BILLING_PAYMENT_REQUIRED: "paymentRequired",
        BILLING_PAYMENT_FAILED: "paymentFailed",
        BILLING_RECONCILIATION_REQUIRED: "reconciliationRequired",
        BILLING_UNCHANGED: "unchanged"
    };
    return body?.status === 409 && Object.prototype.hasOwnProperty.call(codes, body.data?.code) &&
        codes[body.data.code] === body.data.result;
}

function currentPaymentURL(paymentURL) {
    try {
        const url = new URL(paymentURL);
        return url.protocol === "https:" && url.hostname === "invoice.stripe.com" ? url.href : null;
    } catch { return null; }
}

export async function requestSubscriptionReconciliation({ organizationID, BOstagesAccountID, onError }) {
    return requestSubscriptionActivation({ organizationID, BOstagesAccountID, reconcileOnly: true, onError });
}

export function isVerifiedActivation(data) {
    return data?.result === "activated" && data.subscriptionPlanStatus === "Active" &&
        Array.isArray(data.subscriptionPlanIDs) && data.subscriptionPlanIDs.length > 0 &&
        typeof data.subscriptionPlanTime === "string";
}

export async function requestInviteUpdate({ inviteID }) {
    const res = await Library.makeApiRequest({
        endpoint: "Invites/updateInvite",
        data: {
            inviteID,
            status: "Enrolling"
        }
    });

    return res?.data?.status === 200;
}
// #endregion REQUESTS
